import { Box, Grid } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as mealItemSlice from "../features/nutrition/meal-items/meal-item.slice";
import Loader from "../components/loader";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import useMealItems from "../hooks/use-meal-items";
import MealItemTable from "../features/nutrition/meal-items/components/meal-item-table";
import MealItemForm from "../features/nutrition/meal-items/components/meal-item-form";
import { MealItemRequest } from "../service/model/nutrition.model";
import SearchBox from "../components/search-box";
import CreateButton from "../components/create-button";

const MealItems = () => {
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;
    const [showMealItemForm, setShowMealItemForm] = useState(false);
    const isLoading = useAppSelector(mealItemSlice.selectIsLoading);

    const [mealItems] = useMealItems();

    const [name, setName] = useState("");

    const handleSubmit = (data: MealItemRequest) => {
        loggedInUser && dispatch(mealItemSlice.createMealItem({ ...data, })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowMealItemForm(false);
            }
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {mealItems &&
                <>
                    <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowMealItemForm(true)} style={{ marginBottom: "12px" }}>Add Meal Item</CreateButton>
                    </Box>
                    <Grid container direction="row" style={{ marginTop: '12px', alignItems: 'center' }}>
                        <Grid size={{ xs: 12, lg: 4 }}>
                            <SearchBox placeholder="Search by name" setSearchValue={setName} />
                        </Grid>
                    </Grid>
                    <MealItemTable mealItems={mealItems.filter(item => item.name.toLowerCase().includes(name.toLowerCase()))} />
                    {showMealItemForm &&
                        <MealItemForm mealItem={undefined} editable={true} onClose={() => setShowMealItemForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default MealItems;